import { isFormUiSchemaFile } from "@/domain/process-model/form-files";

/**
 * 新しいフォーム定義の雛形。
 *
 * 空の JSON Schema を置くと、User Task に紐付けても項目が 1 つも描かれない
 * （RJSF は `properties` が無ければ何も出さない）。「作ったのに何も出ない」を
 * 避けるため、JSON Schema は 1 項目を持たせて紐付ければ動く状態にする。
 * 続きは編集で足す（項目を組み立てる GUI は作らない）。
 *
 * UI Schema は項目を持たないので空のオブジェクトにする。
 */
export function buildFormTemplate(fileName: string): string {
  if (isFormUiSchemaFile(fileName)) return "{}\n";

  return `${JSON.stringify(
    {
      title: "フォームの見出し",
      type: "object",
      required: ["field_1"],
      properties: {
        field_1: { type: "string", title: "項目 1" },
      },
    },
    null,
    2,
  )}\n`;
}
